const cpArgExportPrivacyPolicy = {
    special_data: [
        {
            lang: '英语',
            privacy_url: 'https://profile.mars.games/static-page/privacy-policy-en.html',
            service_url: 'https://profile.mars.games/static-page/terms-of-service-en.html',
        },
    ],
    not_special_data: [
        {
            lang: '阿语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(AR).html',
            service_url: 'http://www.oasgames.com/TermsofService(AR).html',
        },
        {
            lang: '德语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(DE).html',
            service_url: 'http://www.oasgames.com/TermsofService(DE).html',
        },
        {
            lang: '希腊语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(EL).html',
            service_url: 'http://www.oasgames.com/TermsofService(EL).html',
        },
        {
            lang: '英语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(EN).html',
            service_url: 'http://www.oasgames.com/TermsofService(EN).html',
        },
        {
            lang: '西班牙语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(ES).html',
            service_url: 'http://www.oasgames.com/TermsofService(ES).html',
        },
        {
            lang: '法语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(FR).html',
            service_url: 'http://www.oasgames.com/TermsofService(FR).html',
        },
        {
            lang: '意大利语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(IT).html',
            service_url: 'http://www.oasgames.com/TermsofService(IT).html',
        },
        {
            lang: '波兰语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(PL).html',
            service_url: 'http://www.oasgames.com/TermsofService(PL).html',
        },
        {
            lang: '俄语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(RU).html',
            service_url: 'http://www.oasgames.com/TermsofService(RU).html',
        },
        {
            lang: '荷兰语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(NL).html',
            service_url: 'http://www.oasgames.com/TermsofService(NL).html',
        },
        {
            lang: '葡萄牙语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(PT).html',
            service_url: 'http://www.oasgames.com/TermsofService(PT).html',
        },
        {
            lang: '瑞典语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(SV).html',
            service_url: 'http://www.oasgames.com/TermsofService(SV).html',
        },
        {
            lang: '土耳其语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(TR).html',
            service_url: 'http://www.oasgames.com/TermsofService(TR).html',
        },
        {
            lang: '繁体中文',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(TW).html',
            service_url: 'http://www.oasgames.com/TermsofService(TW).html',
        },
        {
            lang: '韩语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(KO).html',
            service_url: 'http://www.oasgames.com/TermsofService(KO).html',
        },
        {
            lang: '泰语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(TH).html',
            service_url: 'http://www.oasgames.com/TermsofService(TH).html',
        },
        {
            lang: '越南语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(VI).html',
            service_url: 'http://www.oasgames.com/TermsofService(VI).html',
        },
        {
            lang: '日语',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(JA).html',
            service_url: 'http://www.oasgames.com/TermsofService(JA).html',
        },
        {
            lang: '简体中文',
            privacy_url: 'http://www.oasgames.com/PrivacyPolicy(ZH).html',
            service_url: 'http://www.oasgames.com/TermsofService(ZH).html',
        },
    ]
};

export default cpArgExportPrivacyPolicy;



// WEBPACK FOOTER //
// ./website/helper/cpArgExportPrivacyPolicy.js